module.exports = __webpack_public_path__ + "img/image.ffcd5e80.svg";